import { render, staticRenderFns } from "./max-width.template.vue?vue&type=template&id=43cb64dc&scoped=true&"
var script = {}
import style0 from "./max-width.template.vue?vue&type=style&index=0&id=43cb64dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cb64dc",
  null
  
)

export default component.exports